(function () {
  // ---- Config ----
  const SWATCH_SELECTOR = ".swatch-custom a";
  const MAX_CONCURRENT = 4;

  // --- Helpers for "Color: X" label ---
  function titleCase(s) {
    return (s || "")
      .toLowerCase()
      .split(/[\s-]+/)
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  }

  function getColorFromHandleFallback() {
    // Example pathname: /products/positano-floral-print-mini-dress-yellow
    const path = window.location.pathname || "";
    const m = path.match(/\/products\/([^/?#]+)/i);
    if (!m) return "";

    const handle = m[1]; // positano-floral-print-mini-dress-yellow
    const parts = handle.split("-");
    if (parts.length < 2) return "";

    const last = parts[parts.length - 1]; // yellow
    return titleCase(last);
  }

  function setSelectedColorFromActiveSwatch() {
    const label = document.querySelector("[data-swatch-selected]");
    if (!label) return;

    // Prefer active swatch title if swatches exist
    const active = document.querySelector(".swatch-custom li.active a");
    if (active) {
      const title = (active.getAttribute("title") || "").trim();
      if (title) {
        label.textContent = title;
        return;
      }
    }

    // Fallback: derive from URL handle last segment
    const fromUrl = getColorFromHandleFallback();
    label.textContent = fromUrl || "—";
  }

  // Simple in-memory cache so repeat pages don’t re-fetch the same handles
  const cache = (window.__swatchProductCache =
    window.__swatchProductCache || new Map());

  function getHandleFromHref(href) {
    if (!href) return null;
    // href examples:
    // /products/nerine-crochet-lace-mesh-jumpsuit-black
    // https://www.emprada.com/products/nerine-crochet-lace-mesh-jumpsuit-black
    const m = href.match(/\/products\/([^/?#]+)/i);
    return m ? m[1] : null;
  }

  function setSwatchThumb(anchorEl, imageUrl) {
    if (!imageUrl) return;

    anchorEl.style.backgroundImage = `url("${imageUrl}")`;
    anchorEl.style.backgroundSize = "cover";
    anchorEl.style.backgroundPosition = "center";
    anchorEl.style.backgroundRepeat = "no-repeat";

    // Hide the letter fallback if present
    const fallback = anchorEl.querySelector(".swatch-custom__fallback");
    if (fallback) fallback.style.display = "none";

    // Optional: if there is an <img> inside (some configs), hide it to keep consistent thumbnails
    const img = anchorEl.querySelector("img");
    if (img) img.style.display = "none";

    // Removes extra top padding when thumbnail is applied (your Liquid/CSS had padding-top: 7px)
    anchorEl.style.paddingTop = "0";

    anchorEl.classList.add("swatch-thumb-ready");
  }

  async function fetchProductJson(handle) {
    if (cache.has(handle)) return cache.get(handle);

    const url = `/products/${handle}.js`;
    const p = fetch(url, { credentials: "same-origin" })
      .then(async (res) => {
        if (!res.ok) throw new Error(`Fetch failed ${res.status} for ${url}`);
        return res.json();
      })
      .then((data) => {
        cache.set(handle, data);
        return data;
      })
      .catch(() => {
        // Cache a null to avoid repeated failing calls
        cache.set(handle, null);
        return null;
      });

    cache.set(handle, p); // store the promise immediately (dedupe concurrent)
    return p;
  }

  async function upgradeOne(anchorEl) {
    // Don’t do it twice
    if (anchorEl.dataset.swatchUpgraded === "1") return;
    anchorEl.dataset.swatchUpgraded = "1";

    const handle = getHandleFromHref(anchorEl.getAttribute("href"));
    if (!handle) return;

    const data = await fetchProductJson(handle);
    if (!data) return;

    // Shopify product JSON typically uses featured_image (string URL)
    const img = data.featured_image || "";
    if (!img) return;

    setSwatchThumb(anchorEl, img);
  }

  async function runWithConcurrency(items, worker, maxConcurrent) {
    const queue = items.slice();
    const runners = new Array(Math.min(maxConcurrent, queue.length))
      .fill(null)
      .map(async () => {
        while (queue.length) {
          const item = queue.shift();
          try {
            await worker(item);
          } catch (e) {
            // swallow; we never want swatches to break the page
          }
        }
      });
    await Promise.all(runners);
  }

  function collectSwatches(root) {
    const anchors = Array.from(
      (root || document).querySelectorAll(SWATCH_SELECTOR)
    );
    // Filter out ones that already have a background-image set
    return anchors.filter((a) => {
      const bg = a.style.backgroundImage || "";
      return !bg || bg === "none";
    });
  }

  async function upgradeSwatches(root) {
    const swatches = collectSwatches(root);
    if (!swatches.length) return;
    await runWithConcurrency(swatches, upgradeOne, MAX_CONCURRENT);
  }

  // Run on initial load
  function init() {
    // 1) Upgrade swatches to image thumbnails, then set label (safe timing)
    upgradeSwatches(document).finally(() => {
      setSelectedColorFromActiveSwatch();
    });

    // 2) Update label immediately when a swatch is clicked
    document.addEventListener("click", (e) => {
      const target = e.target;
      if (!target || !target.closest) return;

      const a = target.closest(".swatch-custom a");
      if (!a) return;

      const label = document.querySelector("[data-swatch-selected]");
      if (!label) return;

      const title = (a.getAttribute("title") || "").trim();
      // If swatches exist, always prefer swatch title. Otherwise fallback to URL.
      label.textContent = title || getColorFromHandleFallback() || "—";
    });

    // 3) Re-run when Shopify dynamically reloads sections (theme editor / ajax)
    document.addEventListener("shopify:section:load", (e) => {
      upgradeSwatches(e.target).finally(() => {
        setSelectedColorFromActiveSwatch();
      });
    });

    document.addEventListener("shopify:section:reorder", () => {
      upgradeSwatches(document).finally(() => {
        setSelectedColorFromActiveSwatch();
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
